import React from "react";
import { ReportSummaryColors } from "../../constants/ReportSummaryColors";
import style from "./style/ResultColorBar.module.scss";

export interface ResultColorBarProps {
    text?: React.ReactNode;
    htmlText?: string;
    color: ReportSummaryColors | null;
    classes?: { root: string };
}

const ResultColorBar = ({ text, htmlText, color, classes = { root: "" } }: ResultColorBarProps) => {
    const createDOMPurify = require("isomorphic-dompurify");
    const DOMPurify = createDOMPurify(window);

    const textPresentation = htmlText ? (
        <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(htmlText) }} />
    ) : (
        text
    );

    return (
        <div
            className={`${style.result} ${classes?.root || ""}`}
            data-testid="result-color-bar"
            style={
                {
                    "--result-bar-color": color,
                } as React.CSSProperties
            }
        >
            {textPresentation}
        </div>
    );
};

export default ResultColorBar;
